/** 사용량 화면 공통 — 기간(한국 날짜)과 돈 표시. */

const KST_DATE = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Seoul' });

/** 한국 날짜 'YYYY-MM-DD'. */
export const kstDate = (d: Date = new Date()): string => KST_DATE.format(d);

/** 'YYYY-MM-DD' 에 n일 더한 날짜. */
export const addDays = (day: string, n: number): string => {
  const d = new Date(`${day}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** 한국 날짜 from~to(둘 다 포함)를 서버가 받는 [start, end) 시각으로. */
export const kstPeriod = (from: string, to: string) => ({
  start: `${from}T00:00:00+09:00`,
  end: `${addDays(to, 1)}T00:00:00+09:00`,
});

/** from~to 사이 모든 날짜 — 호출이 없는 날도 차트에 빈 칸으로 남긴다. */
export const daysBetween = (from: string, to: string): string[] => {
  const days: string[] = [];
  for (let d = from; d <= to && days.length < 400; d = addDays(d, 1)) days.push(d);
  return days;
};

export const formatKrw = (usd: number, rate: number): string => {
  const krw = usd * rate;
  if (krw === 0) return '₩0';
  if (Math.abs(krw) < 10) return `₩${krw.toFixed(2)}`;
  return `₩${Math.round(krw).toLocaleString('ko-KR')}`;
};

export const formatUsd = (usd: number): string => {
  if (usd === 0) return '$0';
  if (Math.abs(usd) < 0.01) return `$${usd.toPrecision(2)}`;
  return `$${usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;
};

export const formatInt = (n: number): string => Math.round(n).toLocaleString('ko-KR');

const KST_TIME = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export const formatKstTime = (iso: string): string => KST_TIME.format(new Date(iso));

/** 종류별 고정 색 — 필터로 종류가 빠져도 남은 것의 색이 바뀌지 않게 이름에 묶는다. */
export const KIND_COLORS: Record<string, string> = {
  llm: '#2a78d6',
  image: '#eb6834',
  search: '#1baf7a',
  places: '#eda100',
  weather: '#e87ba4',
};
export const KIND_ORDER = Object.keys(KIND_COLORS);
export const kindColor = (kind: string): string => KIND_COLORS[kind] ?? '#94a3b8';

export const totalTokens = (t: {
  input_tokens: number;
  cache_read_tokens: number;
  cache_write_tokens: number;
  output_tokens: number;
  reasoning_tokens: number;
}): number => t.input_tokens + t.cache_read_tokens + t.cache_write_tokens + t.output_tokens + t.reasoning_tokens;
